// removed by extract-text-webpack-plugin
module.exports = {"button":"NavigationButton__button___S7LA2"};